import React from "react";
import leadImage from "../../assets/images/lead.png";
import leadMap from "../../assets/images/lead-map.svg";
import "./Lead.css";

const Lead = () => {
  return (
    <section className="lead">
      <h1 className="lead__title">Путешествия по России</h1>
      <h2 className="lead__subtitle">
        Настоящая страна не в выпусках
        <br />
        новостей, а здесь.
      </h2>
      <div
        className="lead__image"
        style={{ backgroundImage: `url(${leadImage})` }}
      >
        <img className="lead__image-map" src={leadMap} alt="Карта маршрута" />
      </div>
      <span className="lead__caption">ваша полка — верхняя</span>
    </section>
  );
};

export default Lead;
